import script from "./LootBoxBundle.vue?vue&type=script&lang=ts&setup=true"
export * from "./LootBoxBundle.vue?vue&type=script&lang=ts&setup=true"

import "./LootBoxBundle.vue?vue&type=style&index=0&id=095076c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-095076c0"]])

export default __exports__